/**
 * @author: Codex
 * @date: 2026/08/11
 * @desc: CasualGamesHub/NarrativeMerge2TopCharts - 剧情二合品类游戏榜单
 */
import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import ReusePageTemplate from '@intelligence/v3/components/ReusePageTemplate';
import ActiveUsers from '@intelligence/v3/pages/TopCharts/MobileGames/ActiveUsers';

interface INarrativeMerge2TopChartsProps extends IBaseProps {}

const NarrativeMerge2TopCharts: React.FC<INarrativeMerge2TopChartsProps> = (props) => {
  const { style, className } = props;

  const { formatMessage } = useIntl();

  return (
    <ReusePageTemplate
      style={style}
      className={classnames('dbi-reuse-page-narrative-merge2-top-charts', className)}
      title={formatMessage({ id: 'dbi_reuse_page_title_narrative_merge2_top_charts' })}
      subTitle={formatMessage({ id: 'dbi_reuse_page_sub_title_narrative_merge2_top_charts' })}
    >
      <ActiveUsers
        pageLogConfigKey="casualGamesHubNarrativeMerge2TopCharts"
        downloadLogConfigKey="casualGamesHubNarrativeMerge2TopChartsDownloadClick"
        disableInheritance={true}
      />
    </ReusePageTemplate>
  );
};

export default NarrativeMerge2TopCharts;
